// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '../static/less/reset.css';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)
import Vue from 'vue'
window['Vue'] = Vue

import moment from 'vue-moment'
// import iView from 'iview'
// import 'iview/dist/styles/iview.css'

import iView from 'view-design'
import 'view-design/dist/styles/iview.css'

import Config from './config/index'

import App from './App'

import router from './router/router'

// store为实例化生成的
import store from './store'

import Sto from 'store'

// 自定义指令集
import './directive/directives'

// import ConsoleTopbar from '../views/components/layout/consoleTopbar.vue';
// Vue.component('ConsoleTopbar', ConsoleTopbar)
//图片放大预览
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import BaseApi from './api/BaseApi'
window['BaseApi'] = BaseApi
//图片预览
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

// import tinymce from "tinymce";
// import "tinymce/themes/silver";
// import Editor from "@tinymce/tinymce-vue";
//富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

Viewer.setDefaults({
	Options: {
		'zIndex': 9999,
		'inline': true,
		'button': true,
		'navbar': true,
		'title': true,
		'toolbar': true,
		'tooltip': true,
		'movable': true,
		'zoomable': true,
		'rotatable': true,
		'scalable': true,
		'transition': true,
		'fullscreen': true,
		'keyboard': true,
		'url': 'data-source'
	}
})

import {
	videoPlayer
} from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

// 自定义滚动条
import "overlayscrollbars/css/OverlayScrollbars.css";
import OverlayScrollbars from "overlayscrollbars";
import { OverlayScrollbarsPlugin } from "overlayscrollbars-vue";

Vue.use(OverlayScrollbarsPlugin);
Vue.use(OverlayScrollbars);

// 静态函数和新增属性定义
import './helper/helper';
import {
	Message,
	Loading
} from 'element-ui'
// import {Message, Loading} from 'iview'


// edit里的$需要定义
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
window["m7$"] = $

// 载入全局变量

/*富文本编辑器*/
// import VueFroala from 'vue-froala-wysiwyg'
// edit.js核心文件
// import "froala-editor/js/froala_editor.pkgd.min.js";
// import "froala-editor/js/languages/zh_cn";
// // edit.css样式核心文件
// import "froala-editor/css/froala_editor.pkgd.min.css";
// import "font-awesome/css/font-awesome.css";
// import "froala-editor/css/froala_style.min.css";
// Vue.use(VueFroala)

// import VueQuillEditor from 'vue-quill-editor';
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// Vue.use(VueQuillEditor);

/*富文本编辑器结束*/

Vue.use(moment)
Vue.use(iView)

Vue.prototype.$loading = Loading
Vue.prototype.$message = Message

Vue.prototype.$sto = Sto
Vue.prototype.$conf = Config

// 容联七陌呼叫组件
Vue.prototype.moorCall = {}
Vue.prototype.phone = null
Vue.prototype.softphoneBar = null
Vue.prototype.callProcessor = null
Vue.prototype.monitor = null
Vue.prototype.isSuperAdmin = false
Vue.prototype.isCtiRelogin = false
Vue.prototype.monitorTimers = []
Vue.prototype._cti_peerstate = null
Vue.prototype.currentEventObj = {}
Vue.prototype.account = {}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	},
	render: h => h(App),
	mounted() {
		document.dispatchEvent(new Event('render-event'))
	}
})



// WEBPACK FOOTER //
// ./src/main.js